import { Stack, Typography } from '@mui/material';

export const NotDataScenery: React.FC<{
	showDpvalePromotion: boolean;
}> = ({ showDpvalePromotion }) => (
	<Stack mt={'12px'}>
		<Stack direction={'row'}>
			{showDpvalePromotion ? (
				<Typography
					component={'span'}
					sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'normal' }}
				>
					{'Ha ocurrido un error consultando las promociones disponibles.'}
				</Typography>
			) : null}
		</Stack>
	</Stack>
);
